import React from "react";

interface PageDropdownSelectProps {
  limit: number;
  onChangeLimit: (value: number) => void;
  page: number;
  total: number;
  itemLabel?: string;
  disabled?: boolean;
}

const PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100];

const PageDropdownSelect: React.FC<PageDropdownSelectProps> = ({
  limit,
  onChangeLimit,
  page,
  total,
  itemLabel = "Items",
  disabled = false,
}) => {
  const start = total === 0 ? 0 : (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  return (
    <div className="flex items-center gap-3 text-sm text-slate-600">
      <span>Show</span>
      <select
        value={limit}
        disabled={disabled}
        onChange={(e) => onChangeLimit(Number(e.target.value))}
        className="h-9 rounded-xl border border-slate-200 bg-white px-2 text-sm font-semibold text-slate-700 focus:outline-none focus:ring-2 focus:ring-primary/30 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {PAGE_SIZE_OPTIONS.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
      <span>
        Showing {start} to {end} of {total} {itemLabel}
      </span>
    </div>
  );
};

export default PageDropdownSelect;
